module.exports = __webpack_public_path__ + "static/media/logo-side-w.381c680e.png";